export const socialsData = {
  github: "https://github.com/rahulyo954030",
  linkedIn: "https://www.linkedin.com/in/rahul-singh-437a4b234/",
  instagram: "https://www.instagram.com/rahulsingh954030/",
  codepen: "https://codepen.io/rahulyo954030",
  twitter: "https://twitter.com/rahulyo954030",
  reddit: "https://www.reddit.com/user/rahulyo954030",
  blogger: "https://medium.com/@rahul954030",
  medium: "https://medium.com/@rahul954030",
  stackOverflow: "https://stackoverflow.com/users/19259447/rahul-singh",
  gitlab: "https://gitlab.com/rahulyo954030",
  youtube: "https://www.youtube.com/channel/UCrzi1hHbpXC2STVDwoihhKA",
  resume:
    "https://drive.google.com/file/d/1qsR2NV1L8mYt6_vKj9dFhEWcdft2D4gv/view?usp=sharing",
};
